import React, {useEffect, useState} from 'react';
import EventRow from './eventRow/eventRow';
import './task-events.scss';
import {sortingEnumForPue} from '../../../../../../utils/constants';
import SingleSelectCheckmarks from '../../../components/single-select-checkbox/singleSelectCheckBox';
import CustomCollapse from '../../../../../../components/collapse/collapse';
import EnhancedFunctionalSafety from './enhancedFunctionalSafety/enhancedFunctionalSafety';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Button from '../../../../../../components/form/button/button';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addEventToTask } from '../../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import { getRiskAssessmentCoreLoadingState } from '../../../../../../redux/selectors/riskAssessmentCore';
import AddFailureModeModal from './add-failure-mode-modal';
import { getUserRoleName } from '../../../../../../utils/constants';
import { getLoginStateSelector } from '../../../../../../redux/selectors/loginSelector';

export default function TaskEvents({taskData, eventData}) {
  const [eventList, setEventList] = useState([]);
  const [showAddFailureModeModal, setShowAddFailureModeModal] = useState(false);
  const [mplComparison, setMplComparison] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector(getRiskAssessmentCoreLoadingState());
  const loginState = useSelector(getLoginStateSelector());
  const {loggedInUser} = loginState;
  const readOnly = getUserRoleName(loggedInUser?.role) === 'general';

  useEffect(() => {
    sortedDataHandler();
  }, [eventData]);

  const sortedDataHandler = () => {
    const sortedData = eventData.sort((a, b) =>
      Number(a.event_detail?.event_sequence) >
      Number(b.event_detail?.event_sequence)
        ? 1
        : -1,
    );
    setEventList(sortedData);
  };

  const handleOrderingChange = e => {
    if (e?.id === 'all') {
      sortedDataHandler();
    } else {
      const filteredEvents = eventData.filter(
        event => event?.event_status === Number(e?.id),
      );
      setEventList(filteredEvents);
    }
  };

  const handleAddFailureMode = (values) => {
    if (!taskData?.id) {
      return;
    }
    
    dispatch(
      addEventToTask({
        taskId: taskData.id,
        payload: {
          event_name: values.event_name,
          description: values.description || null,
        },
        callback: () => {
          setShowAddFailureModeModal(false);
        },
      })
    );
  };

 


  return (

    <>
   
      {/* <div style={{display: 'flex', width: '100%'}}>
        <h4 style={{padding: '10px 0px'}}>Potential Unwanted Events</h4>
        <div style={{marginLeft: 'auto'}}>
          <SingleSelectCheckmarks
            data={sortingEnumForPue}
            handleOrderingChange={handleOrderingChange}
          />
        </div>
      </div> */}



     
{  location.state?.type === 2 ?  <div className="event-list-wrapper"> <div style={{display:"flex",flexDirection:"column",gap:"12px",padding:"1rem"}} className="event-list-wrapper">
        {/* MPL Comparison - Outside both collapses */}
        {mplComparison?.mplaValue && mplComparison?.mplr && mplComparison?.mplPassFail && (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '0.5rem',
          padding: '0.75rem',
          backgroundColor: mplComparison.mplPassFail === 'PASS' ? '#e8f5e9' : '#ffebee',
          border: `1px solid ${mplComparison.mplPassFail === 'PASS' ? '#4caf50' : '#f44336'}`,
          borderRadius: '4px',
          marginTop: '0.5rem'
        }}>
          <div style={{ 
            fontWeight: 'bold', 
            fontSize: '0.95rem',
            color: mplComparison.mplPassFail === 'PASS' ? '#2e7d32' : '#c62828'
          }}>
            MPL Comparison: {mplComparison.mplPassFail === 'PASS' ? '✓ PASS' : '✗ FAIL'}
          </div>
          <div style={{ fontSize: '0.875rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
            <div>MPLa: {mplComparison.mplaValue}</div>
            <div>MPLr: {mplComparison.mplr}</div>
            <div style={{ fontStyle: 'italic', marginTop: '0.25rem' }}>
              {mplComparison.mplPassFail === 'PASS' 
                ? 'System meets required performance level' 
                : 'System does not meet required performance level'}
            </div>
          </div>
        </div>
      )}
     <CustomCollapse
        btnText={`Machine Performance Level Required (MPLr)`}
      >
        <div style={{display: 'flex', width: '100%', alignItems: 'center'}}>
          <h4 style={{padding: '10px 0px', margin: 0}}>Failure Modes</h4>

          <div style={{marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center'}}>
            {!readOnly && (
              <Button
                variant="submit-button"
                clickHandler={() => setShowAddFailureModeModal(true)}
                style={{padding: '0.5rem 1rem', fontSize: '0.875rem'}}>
                + Add Failure Mode
              </Button>
            )}
            <SingleSelectCheckmarks
              data={sortingEnumForPue}
              handleOrderingChange={handleOrderingChange}
            />
          </div>
        </div>
      { taskData?.worst_score && <h6 style={{color:"red"}}> MPLr: {taskData?.worst_score}</h6>}

        {eventList.map(event => (
          <EventRow key={event.id} data={event} />
        ))}
      </CustomCollapse>

      <CustomCollapse btnText={'Machine Performance Level Achieved (MPLa) '}>
        <EnhancedFunctionalSafety
          taskId={taskData?.id}
          mplr={taskData?.worst_score}
          onScoresChange={setMplComparison}
        />
      </CustomCollapse>


      </div> </div> :<div className="event-list-wrapper"> <div style={{display: 'flex', width: '100%'}}>
        <h4 style={{padding: '10px 0px'}}>Potential Unwanted Events</h4>
        <div style={{marginLeft: 'auto'}}>
          <SingleSelectCheckmarks
            data={sortingEnumForPue}
            handleOrderingChange={handleOrderingChange}
          />
        </div>
      </div>

      {eventList.map(event => (
        <EventRow key={event.id} data={event} />
      ))}
    </div>}

      <AddFailureModeModal
        show={showAddFailureModeModal}
        setShow={setShowAddFailureModeModal}
        onSubmit={handleAddFailureMode}
        isLoading={isLoading}
      />

    </>
  );
}
